<template>
  <div class="row bgc-wrapper margin-top-42">
    <div class="col-12 traveller-heading accordion-toggle"> 
      <div class="row">
        <div>
          <button
            id="trans_of_ownship"
            type="button"
            class="expand-form-button"
            data-toggle="collapse"
            aria-label="Expand Journey Details"
            data-target="#TransferOfOwnership"
          >
            <img alt="Toggle Policy Details" src="@/assets/images/arr-up.png" />
          </button>
        </div>
        <h3>Transfer of Ownership</h3>
      </div> 
    </div>
    <div class="collapse show col-12 bgc-form-box" id="transferOfOwnership">
      <!-- <div class="risk row"> -->
      <div v-if="transferOfOwnershipData.partyType.visibility"> 
        <div class="col-12 types-of-plans-form-box mt-2" >
            <div class="row" :class="{'disable-temp-block':validationSuccess}" >
                <div class="col-12 col-lg-5 pl-0 bgc-name">
                    <div class="row party-wrap">
                        <div class="party-switch">
                            <input id="motor-party" type="radio" name='plancategory' v-model="switchParty.value" @change="switchAddparty('showAddParty')" value='motor-party' checked="checked" />
                            <label for="motor-party" class="party-switch-label pl-2" >Add Party</label>
                            <input id="party-personal-guard" type="radio" name='plancategory' v-model="switchParty.value" @change="switchAddparty('showSearchParty')" value='party-personal-guard' />
                            <label for="party-personal-guard" class="party-switch-label text-center party-personal-guard text-ellipsis">Search Party</label>
                            <div class="party-switch-indicator"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- </div>  -->
        <div class="risk row" >
          <!-- Party Type* starts-->
          <div class=" col-lg-3 col-md-3 col-sm-6 " :class="{'disable-temp-block':validationSuccess}" >
            <div class="row form-group">
              <float-label
              label="Party Type*"
              :fixed="isFloat(transferOfOwnershipData.partyType.value)"
            >
            <select
            class="form-control"
            placeholder="Party Type*"
            @change="changePartyType()"
            v-model="transferOfOwnershipData.partyType.value"
            v-evolvews="transferOfOwnershipData.partyType"
            :class="{ 'bgc-error-field': transferOfOwnershipData.partyType.errorText!=='' }"
            >
            <option disabled selected value>Party type*</option>
            <option value="I">Individual</option>
            <option value="O">Organization</option>
            </select>
            </float-label>
            <span
              class="error-text" v-if="transferOfOwnershipData.partyType.errorText !== ''" >
              {{transferOfOwnershipData.partyType.errorText}}</span>
            </div>
          </div>
          <!-- Party Type* ends-->
          <!-- Party Code* starts-->
          <div class="searchNumber col-lg-3 col-md-3 col-sm-6 pr-0" v-if="!showAddParty.value" >
            <div class="row form-group ">
              <float-label 
                :fixed="isFloat(transferOfOwnershipData.partyId.value)"
                label="Party Code*"
              >
                <input
                  type="text"
                  placeholder="Party Code*"
                  aria-label="Party Code*"
                  class="form-control search-input-field existing-party-id"
                  :class="{
                  'bgc-error-field':transferOfOwnershipData.partyId.errorText !=='',
                  }"
                  maxlength="15"
                  autocomplete="off"
                  v-on:keydown="alphaNumeric"
                  v-model="transferOfOwnershipData.partyId.value"
                  v-evolvews="transferOfOwnershipData.partyId"
                /> 
                <button id="search_pinNo_btn" class="input-group-append search-field-btn pl-sm-0" @click="callSearchParty()"
                 :class="{'bgc-error-field':transferOfOwnershipData.partyId.errorText !==''}" >
                  <span class="input-group-text">
                    <img src="@/assets/images/black@2x.png" alt="search" class="img-responsive"/>
                  </span>
                </button> 
                <!-- <span v-if="searchPartyLoader" class="search-loader small inline"><img src="@/assets/images/loader.gif" alt="Pin Loader"
                  class="search-loader-breakdown"/></span> -->
              </float-label>
            <span
              class="error-text" v-if="transferOfOwnershipData.partyId.errorText !== ''" >
              {{transferOfOwnershipData.partyId.errorText}}</span>
            </div>
          </div> 
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 pr-0" v-if="!showAddParty.value" >
            <div class="row form-group adv-search-div ml-0">
              <a
                href="#"
                class="add-wrapper bgc-links adv-search collapsed"
                data-toggle="modal"
                data-target="#searchPartyModal"
                @click="state.showModal=true"
              >Advanced Search</a> 
            </div>
          </div>
          <!-- Party Code* end-->
        </div>
        <div class="row">
          <h4 class="partystatusclass font-weight-bold" v-if="checkPartyStatus" >{{checkPartyStatus}}</h4>
        </div>
        <div v-if="transferOfOwnershipData.partyType.value == 'O' && showAddParty.value" :class="{'disable-temp-block':validationSuccess}">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6">
              <div class="row form-group">
              <float-label 
                :fixed="isFloat(transferOfOwnershipData.gstNumber.value)" 
                label="GSTN Number">
                <input
                  type="text"
                  class="form-control"
                  @blur="validateGstUsingPAN()"
                  v-on:keyup="alphaNumeric+toUpperCase()"
                  :placeholder="transferOfOwnershipData.gstNumber.stepsMandatory ? 'GSTN Number*' : 'GSTN Number'"
                  maxlength="15"
                  :class="{ 'bgc-error-field': transferOfOwnershipData.gstNumber.errorText!=='' }"
                  v-evolvews="transferOfOwnershipData.gstNumber"
                  v-model="transferOfOwnershipData.gstNumber.value"
                />
              </float-label>
              <span class="pan-validated success-gst pt-2"
                v-show="!transferOfOwnershipData.gstNumber.errorText && gstNameStatus">{{gstNameStatus.split(':')[0]}} : <span class="font-weight-bold">{{gstNameStatus.split(':')[1]}}</span></span>
              <span
                class="error-text"
                v-if="transferOfOwnershipData.gstNumber.errorText!==''"
              >{{transferOfOwnershipData.gstNumber.errorText}}</span>
              <span v-if="validateGstLoader" class="search-loader-gst small inline"><img src="@/assets/images/loader.gif" alt="Pan Loader"
                class="search-loader-breakdown"/></span>
              </div>
            </div>
            <!-- GSTIN Issuance Date starts -->
            <div class="col-lg-3 col-md-3 col-sm-6">
              <div class="row form-group">
                <float-label 
                  :fixed="isFloat(transferOfOwnershipData.gstIssuanceDate.value)" 
                    label="GSTIN Issuance Date">
                  <datepicker
                      format="dd/MM/yyyy"
                      autocomplete="off"
                      :typeable="true"
                      v-model="transferOfOwnershipData.gstIssuanceDate.value"
                      :input-class="isInputError(transferOfOwnershipData.gstIssuanceDate.errorText)"
                      :disabledDates="validateDate"
                      @datePickerBlurred="checkError(transferOfOwnershipData.gstIssuanceDate,false)"
                      :placeholder="transferOfOwnershipData.gstIssuanceDate.stepsMandatory ? 'GSTIN Issuance Date*' : 'GSTIN Issuance Date'"
                    >
                  </datepicker>
                </float-label>
                <span
                  class="error-text"
                  v-if="transferOfOwnershipData.gstIssuanceDate.errorText!==''"
                >{{transferOfOwnershipData.gstIssuanceDate.errorText}}</span>
              </div>
            </div>
            <!-- GSTIN Issuance Date ends -->
            <!-- GSTN Registration Status starts -->
            <div class="col-lg-3 col-md-3 col-sm-6">
              <div class="row form-group">
                <float-label 
                  :fixed="isFloat(transferOfOwnershipData.gstRegnStatus.value)" 
                  label="GSTN Registration Status">
                  <select
                    class="form-control"
                    v-model="transferOfOwnershipData.gstRegnStatus.value"
                    v-evolvews="transferOfOwnershipData.gstRegnStatus"
                    @change="changeGstValidation()"
                  >
                    <option disabled value='' v-if="transferOfOwnershipData.gstRegnStatus.value==''">GSTN Registration Status</option>
                    <option disabled :value='null' v-if="transferOfOwnershipData.gstRegnStatus.value==null">GSTN Registration Status</option>
                    <option value="PROVREG">Provisional Registration</option>
                    <option value="REG">Registered</option>
                  </select>
                </float-label>
                <span
                  class="error-text"
                  v-if="transferOfOwnershipData.gstRegnStatus.errorText!==''"
                >{{transferOfOwnershipData.gstRegnStatus.errorText}}</span>
              </div>
            </div>
            <!-- GSTN Registration Status ends -->
          </div>
          <div class="row">
            <!-- Organization name starts -->
            <div class="col-lg-3 col-md-3 col-sm-6">
              <div class="row form-group">
              <float-label 
                :fixed="isFloat(transferOfOwnershipData.organizationName.value)" 
                label="Organization Name*">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Organization Name*"
                  maxlength="240"
                  v-on:keydown="alphaNumericSpace"
                  v-model="transferOfOwnershipData.organizationName.value"
                  :class="{ 'bgc-error-field': transferOfOwnershipData.organizationName.errorText!=='' }"
                  v-evolvews="transferOfOwnershipData.organizationName"
                />
              </float-label>
              <span
                class="error-text"
                v-if="transferOfOwnershipData.organizationName.errorText!==''"
              >{{transferOfOwnershipData.organizationName.errorText}}</span>
              </div>
            </div>
            <!-- organization name ends -->
            <!-- radio button starts -->
            <div class="col-lg-5 d-flex">
              <div class="pl-0 bgc-name mt-4">Is this organization a registered business/trust?</div>
                <div class="pr-0 bgc-name mt-4 pt-3">
                    <div class="row vehicle-owned-wrap ml-5">
                        <div class="vehicle-owned-switch">
                            <input id="registered" type="radio" name='vehicle-owned' :value='true' 
                            @change="validateRegBusiness()"
                            v-model="transferOfOwnershipData.registeredBusiness.value" />
                            <label for="registered" class="vehicle-owned-switch-label pl-2">Yes</label>
                            <input id="not-registered" type="radio" name='vehicle-owned'
                            @change="validateRegBusiness()"
                            :value='false' v-model="transferOfOwnershipData.registeredBusiness.value" checked/>
                            <label for="not-registered" class="vehicle-owned-switch-label text-center vehicleownswitch text-ellipsis">No</label>
                            <div class="vehicle-owned-switch-indicator"></div>
                        </div>
                    </div>
              </div>
            </div>
              <!-- radio button ends -->
          </div>
          <div class="row" v-if="transferOfOwnershipData.registeredBusiness.value">
            <!-- Business Registration Number/ Trust Number* starts -->
            <div class="col-lg-3 col-md-3 col-sm-6" >
              <div class="row form-group">
              <float-label 
                :fixed="isFloat(transferOfOwnershipData.businessRegistrationNumber.value)" 
                label="Business Registration Number/ Trust Number*">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Business Registration Number/ Trust Number*"
                  maxlength="30"
                  v-on:keydown="onlyNumber"
                  v-model="transferOfOwnershipData.businessRegistrationNumber.value"
                  :class="{ 'bgc-error-field': transferOfOwnershipData.businessRegistrationNumber.errorText!=='' }"
                  v-evolvews="transferOfOwnershipData.businessRegistrationNumber"
                />
              </float-label>
              <span
                class="error-text"
                v-if="transferOfOwnershipData.businessRegistrationNumber.errorText!==''"
              >{{transferOfOwnershipData.businessRegistrationNumber.errorText}}</span>
              </div>
            </div>
            <!-- Business Registration Number/ Trust Number* ends -->
            <!-- Date of Registration Starts        -->
            <div class="form-group col-lg-3 col-md-3 col-sm-6 p-0">
              <float-label 
                label="Date of Registration*" 
                :fixed="isFloat(transferOfOwnershipData.businessRegistrationDate.value)">
                <datepicker
                  format="dd/MM/yyyy"
                  :typeable="true"
                  v-model="transferOfOwnershipData.businessRegistrationDate.value"
                  :input-class="isInputError(transferOfOwnershipData.businessRegistrationDate.errorText)"
                  :disabledDates="validateDate"
                  @datePickerBlurred="checkError(transferOfOwnershipData.businessRegistrationDate,false)"
                  placeholder="Date of Registration*"
                ></datepicker>
              </float-label>
              <span
                class="error-text"
                v-if="transferOfOwnershipData.businessRegistrationDate.errorText!==''"
              >{{transferOfOwnershipData.businessRegistrationDate.errorText}}</span>
            </div>
            <!-- Date of Registration* ends -->
          </div>
        </div>
        <div :class="{'disable-temp-block':validationSuccess}" >
          <div class="risk row mt-5" >
            <div class="col-lg-12 col-md-12 col-sm-12  traveller-heading accordion-toggle" v-if="showAddParty.value && transferOfOwnershipData.partyType.value == 'I'" >
              <div class="row ">
                <div>
                  <button
                    id="cust_details_ownship"
                    type="button"
                    class="expand-form-button"
                    data-toggle="collapse"
                    aria-label="Expand addPartyExpand"
                    data-target="#addPartyDiv"
                  >
                    <img alt="Toggle addPartyExpand" src="@/assets/images/arr-up.png" />
                  </button>
                </div>
                <h3>Customer Details</h3>
              </div>
            </div>
            <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="addPartyDiv" v-if="showAddParty.value && transferOfOwnershipData.partyType.value == 'I'" >
              <div class="risk row">
                <!--Title* starts-->
                <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="row form-group">
                      <float-label label="Title*" :fixed="isFloat(transferOfOwnershipData.title.value)"> 
                          <select
                              v-model="transferOfOwnershipData.title.value"
                              v-evolvews="transferOfOwnershipData.title"
                              :class="{'bgc-error-field':transferOfOwnershipData.title.errorText !== ''}"
                              class="form-control"
                          >
                          <!-- @click="titleChange()" -->
                              <option disabled value='' v-if="transferOfOwnershipData.title.value==''">Title*</option>
                              <option disabled :value='null' v-if="transferOfOwnershipData.title.value==null">Title*</option>
                              <option v-for="title in state.titleArray" :key="title.code" :value="title.code">{{title.name}}</option>
                          </select>
                      </float-label>
                      <span class="error-text" v-if="transferOfOwnershipData.title.errorText !== ''">
                          {{transferOfOwnershipData.title.errorText}}</span>
                  </div>
                </div>
                <!--Title ends-->
                <!--First Name* start-->
                <div class="col-lg-3 col-md-3 col-sm-6" >
                  <div class="row form-group">
                      <float-label label="First Name*" :fixed="isFloat(transferOfOwnershipData.firstName.value)"> 
                          <input
                              v-model="transferOfOwnershipData.firstName.value"
                              v-evolvews="transferOfOwnershipData.firstName"
                              type="text"
                              maxlength="60"
                              v-on:keydown="onlyCharSpace"
                              :class="{'bgc-error-field':transferOfOwnershipData.firstName.errorText !== ''}"
                              class="form-control"
                              placeholder="First Name*"
                          />
                      </float-label>
                      <span class="error-text" v-if="transferOfOwnershipData.firstName.errorText !== ''">
                          {{transferOfOwnershipData.firstName.errorText}}</span>
                  </div>
                </div>
                <!--First Name* ends-->
                <!--Middle Name starts-->
                <div class="col-lg-3 col-md-3 col-sm-6" >
                    <div class="row form-group">
                        <float-label label="Middle Name" :fixed="isFloat(transferOfOwnershipData.middleName.value)"> 
                            <input
                                v-model="transferOfOwnershipData.middleName.value"
                                v-evolvews="transferOfOwnershipData.middleName"
                                type="text"
                                class="form-control"
                                maxlength="60"
                                v-on:keydown="onlyCharSpace"
                                placeholder="Middle Name"
                            />
                        </float-label>
                        <span class="error-text" v-if="transferOfOwnershipData.middleName.errorText !== ''">
                            {{transferOfOwnershipData.middleName.errorText}}</span>
                    </div>
                </div>
                <!--Middle Name ends-->
                <!--Last Name* starts-->
                <div class="col-lg-3 col-md-3 col-sm-6" >
                  <div class="row form-group">
                    <float-label label="Last Name*" :fixed="isFloat(transferOfOwnershipData.lastName.value)"> 
                        <input
                            v-model="transferOfOwnershipData.lastName.value"
                            v-evolvews="transferOfOwnershipData.lastName"
                            type="text"
                            :class="{'bgc-error-field':transferOfOwnershipData.lastName.errorText !== ''}"
                            class="form-control"
                            placeholder="Last Name*"
                            maxlength="60"
                            v-on:keydown="onlyCharSpace"
                        />
                    </float-label>
                    <span class="error-text" v-if="transferOfOwnershipData.lastName.errorText !== ''">
                        {{transferOfOwnershipData.lastName.errorText}}</span>
                  </div>
                </div>
                <!--Last Name* ends-->
              </div>
              
            </div> 
            
          </div>
          <div class="risk row">
            <!-- Correspondence Address component -->
            <CorrespondenceAddress v-if="showAddParty.value" :panValidate='panValidate' :selectedEndrsType="selectedEndrsType" :addressData="transferOfOwnershipData" :areas="areas" :validatePanLoader="validatePanLoader" :panNameStatus="panNameStatus" :permanentAreas="permanentAreas" ></CorrespondenceAddress>
          </div> 
        </div>
        <div class="risk row mt-3" 
          v-if="(showAddParty.value && hideAddProceed ) || (!showAddParty.value)">
          <div class="col-lg-12 col-md-12 col-sm-12  traveller-heading accordion-toggle"  >
            <div class="row ">
              <div>
                <button
                  id="ownership_details_ownship"
                  type="button"
                  class="expand-form-button"
                  data-toggle="collapse"
                  aria-label="Expand searchPartyexpand"
                  data-target="#searchPartyDiv"
                >
                  <img alt="Toggle searchPartyexpand" src="@/assets/images/arr-up.png" />
                </button>
              </div>
              <h3>Ownership Details</h3>
            </div>
          </div>
          <div class="collapse show col-lg-12 col-md-12 col-sm-12 bgc-form-box" id="searchPartyDiv">
            <div class="risk row">
              <!-- Compulsory Personal Accident Cover Applicability* starts -->
              <div class=" col-lg-3 col-md-3 col-sm-6 " v-if="getSavedQuoteData.motorPolicyBasicDetails.planCode!='1870' && getSavedQuoteData.motorPolicyBasicDetails.planCode!='1871'">
                <div class="row form-group">
                  <float-label
                  label="CPA Cover Applicability*"
                  :fixed="isFloat(transferOfOwnershipData.cpaApplicability.value)">
                  <select
                  class="form-control text-overflow-fix"
                  placeholder="CPA Cover Applicability*"
                  v-model="transferOfOwnershipData.cpaApplicability.value"
                  v-evolvews="transferOfOwnershipData.cpaApplicability"
                  :class="{ 'bgc-error-field': transferOfOwnershipData.cpaApplicability.errorText!=='' }"
                  :disabled="transferOfOwnershipData.partyType.value == 'O'"
                  @change="setExemptionReasons()+getSumInsured('cpaApplicability')+resetData()"
                  >
                  <option disabled :value='null' v-if='transferOfOwnershipData.cpaApplicability.value == null'>Compulsory PA Applicability*</option>
                  <option disabled value=''  v-if='transferOfOwnershipData.cpaApplicability.value == ""'>Compulsory PA Applicability*</option>
                  <option v-for="cpaApplicability in domainValues.cpaApplicabilityResponse.cpaApplicabilityList" v-show="cpaApplicability.code!=='S'"
                  :key="cpaApplicability.code" :value="cpaApplicability.code">{{cpaApplicability.name}}</option>
                  </select>
                </float-label>
                <span
                  class="error-text" v-if="transferOfOwnershipData.cpaApplicability.errorText !== ''" >
                  {{transferOfOwnershipData.cpaApplicability.errorText}}</span>
                </div>
              </div>
              <!-- Compulsory Personal Accident Cover Applicability* ends-->
              <!-- //for plancode 1870 & 1871 cpa value set 'S' % 'NA' -->
              <!-- Compulsory Personal Accident Cover Applicability* starts -->
              <div class=" col-lg-3 col-md-3 col-sm-6 " v-if="getSavedQuoteData.motorPolicyBasicDetails.planCode=='1870' || getSavedQuoteData.motorPolicyBasicDetails.planCode=='1871'">
                <div class="row form-group">
                  <float-label
                  label="CPA Cover Applicability*"
                  :fixed="isFloat(transferOfOwnershipData.cpaApplicability.value)">
                  <select
                  class="form-control text-overflow-fix"
                  placeholder="CPA Cover Applicability*"
                  v-model="transferOfOwnershipData.cpaApplicability.value"
                  v-evolvews="transferOfOwnershipData.cpaApplicability"
                  :class="{ 'bgc-error-field': transferOfOwnershipData.cpaApplicability.errorText!=='' }"
                  :disabled="transferOfOwnershipData.partyType.value == 'O'"
                  @change="setExemptionReasons()+getSumInsured('cpaApplicability')+resetData()"
                  >
                  <option disabled :value='null' v-if='transferOfOwnershipData.cpaApplicability.value == null'>Compulsory PA Applicability*</option>
                  <option disabled value=''  v-if='transferOfOwnershipData.cpaApplicability.value == ""'>Compulsory PA Applicability*</option>
                  <option v-for="cpaApplicability in domainValues.cpaApplicabilityResponse.cpaApplicabilityList" v-show="cpaApplicability.code!=='C' && cpaApplicability.code!=='E'"
                  :key="cpaApplicability.code" :value="cpaApplicability.code">{{cpaApplicability.name}}</option>
                  </select>
                </float-label>
                <span
                  class="error-text" v-if="transferOfOwnershipData.cpaApplicability.errorText !== ''" >
                  {{transferOfOwnershipData.cpaApplicability.errorText}}</span>
                </div>
              </div>
              <!-- Compulsory Personal Accident Cover Applicability* ends-->
              <!-- Exemption Reason* starts-->
              <div class=" col-lg-3 col-md-3 col-sm-6 " v-if="transferOfOwnershipData.cpaApplicability.value == 'E'">
                <div class="row form-group">
                  <float-label
                  label="Exemption Reason*"
                  :fixed="isFloat(transferOfOwnershipData.exemptionReason.value)"
                >
                <select
                class="form-control"
                placeholder="Exemption Reason*"
                :disabled="transferOfOwnershipData.partyType.value == 'O' && transferOfOwnershipData.cpaApplicability.value == 'E'"
                v-model="transferOfOwnershipData.exemptionReason.value"
                v-evolvews="transferOfOwnershipData.exemptionReason"
                @change='resetPAPolicyData()+checkExemption()'
                :class="{ 'bgc-error-field': transferOfOwnershipData.exemptionReason.errorText!=='' }"
                >
                <option disabled :value='null' v-if='transferOfOwnershipData.exemptionReason.value == null'>Exemption Reason*</option>
                <option disabled value=''  v-if='transferOfOwnershipData.exemptionReason.value == ""'>Exemption Reason*</option>
                <option v-for="reason in state.exemptionReasonsList" :key="reason.code" :value="reason.code">{{reason.name}}</option>
                </select>
                </float-label>
                <span
                  class="error-text" v-if="transferOfOwnershipData.exemptionReason.errorText !== ''" >
                  {{transferOfOwnershipData.exemptionReason.errorText}}</span>
                </div>
              </div>
              <!-- Exemption Reason* ends-->
              <!-- CPA Period* starts-->
              <div class=" col-lg-3 col-md-3 col-sm-6 " v-if="transferOfOwnershipData.cpaApplicability.value == 'C'">
                <div class="row form-group">
                  <float-label
                  label="CPA Period*"
                  :fixed="isFloat(transferOfOwnershipData.cpaDuration.value)"
                  >
                  <select
                    class="form-control"
                    placeholder="CPA Period*"
                    v-model="transferOfOwnershipData.cpaDuration.value"
                    v-evolvews="transferOfOwnershipData.cpaDuration"
                    :class="{ 'bgc-error-field': transferOfOwnershipData.cpaDuration.errorText!=='' }"
                    @change="getSumInsured('cpaDuration')"
                  >
                  <!-- <option disabled selected value>CPA Period*</option> -->
                  <option disabled :value='null' v-if='transferOfOwnershipData.cpaDuration.value == null'>CPA Period*</option>
                  <option disabled value=''  v-if='transferOfOwnershipData.cpaDuration.value == ""'>CPA Period*</option>
                  <!-- <option value="3">3</option> -->
                  <option v-for="cpaDuration in cpaDurationList" :key="cpaDuration" :value="cpaDuration">{{cpaDuration}}</option>
                  </select>
                </float-label>
                <span
                    class="error-text" v-if="transferOfOwnershipData.cpaDuration.errorText !== ''" >
                    {{transferOfOwnershipData.cpaDuration.errorText}}</span>
                </div>
              </div>
              <!-- CPA Period* ends-->
            </div>
            <div class="risk row" v-if="transferOfOwnershipData.cpaApplicability.value == 'C' || transferOfOwnershipData.cpaApplicability.value == 'S'">
              <!-- PA Nominee Name starts-->
              <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="row form-group">
                      <float-label label="PA Nominee Name" :fixed="isFloat(transferOfOwnershipData.paNomineeName.value)"> 
                          <input
                              v-model="transferOfOwnershipData.paNomineeName.value"
                              v-evolvews="transferOfOwnershipData.paNomineeName"
                              type="text"
                              maxlength="30"
                              v-on:keydown="onlyCharSpace"
                              class="form-control"
                              placeholder="PA Nominee Name"
                          />
                      </float-label>
                  </div>
              </div>
              <!-- PA Nominee Name ends-->
              <!-- PA Nominee Relation starts-->
              <div class=" col-lg-3 col-md-3 col-sm-6 ">
                  <div class="row form-group">
                      <float-label label="PA Nominee Relation" :fixed="isFloat(transferOfOwnershipData.paNomineeRelation.value)">
                          <select
                          class="form-control"
                          placeholder="PA Nominee Relation"
                          v-model="transferOfOwnershipData.paNomineeRelation.value"
                          v-evolvews="transferOfOwnershipData.paNomineeRelation"
                          >
                              <!-- <option disabled selected value>PA Nominee Relation</option> -->
                              <option disabled value='' v-if="transferOfOwnershipData.paNomineeRelation.value==''">PA Nominee Relation</option>
                              <option disabled :value='null' v-if="transferOfOwnershipData.paNomineeRelation.value==null">PA Nominee Relation</option>
                              <option v-for="relation in domainValues.initMotorDomainLists.nomineeRelations" :key="relation.code" :value="relation.code">{{relation.name}}</option>
                          </select>
                      </float-label>
                  </div>
              </div>
              <!-- PA Nominee Relation ends-->
              <!-- PA Nominee Allocation (%)* starts-->
              <div class="col-lg-3 col-md-3 col-sm-6">
                  <div class="row form-group">
                      <float-label label="PA Nominee Allocation (%)" :fixed="isFloat(transferOfOwnershipData.paNomineeAllocationPercentage.value)"> 
                          <input
                              v-model="transferOfOwnershipData.paNomineeAllocationPercentage.value"
                              v-evolvews="transferOfOwnershipData.paNomineeAllocationPercentage"
                              type="text"
                              v-on:keydown="onlyNumber"
                              disabled
                              maxlength="3"              
                              class="form-control"
                              placeholder="PA Nominee Allocation (%)"
                          />
                      </float-label>
                  </div>
              </div>
              <!-- PA Nominee Allocation (%) ends-->
            </div>
            <div class="risk row" >
              <!-- Vehicle Transferred To Whom Starts-->
              <div class="col-lg-3 col-md-3 col-sm-6" v-if="getSavedQuoteData.motorPolicyBasicDetails.planCode!=='1805' && getSavedQuoteData.motorPolicyBasicDetails.planCode!=='1806' && 
              getSavedQuoteData.motorPolicyBasicDetails.planCode!=='1831'">
                <div class="row form-group">
                    <float-label label="Vehicle Transferred To Whom" :fixed="isFloat(transferOfOwnershipData.vehicleTransferredToWhom.value)">
                        <select
                        class="form-control"
                        placeholder="Vehicle Transferred To Whom"
                        v-model="transferOfOwnershipData.vehicleTransferredToWhom.value"
                        v-evolvews="transferOfOwnershipData.vehicleTransferredToWhom"
                        @change="onChangeVehicleTransferred()"
                        >
                          <option disabled value='' v-if="transferOfOwnershipData.vehicleTransferredToWhom.value==''">Vehicle Transferred To Whom</option>
                          <option disabled :value='null' v-if="transferOfOwnershipData.vehicleTransferredToWhom.value==null">Vehicle Transferred To Whom</option>
                          <option v-for="vehicleTransferObj in vehicleTransferDataArr" :key="vehicleTransferObj.code" :value="vehicleTransferObj.code">{{vehicleTransferObj.name}}</option>
                        </select>
                    </float-label>
                </div>
              </div>
              <!--Vehicle Transferred To Whom ends-->
            </div>
            <div class="risk row">
              <!--PA Policy Number  starts-->
              <div class="col-lg-3 col-md-3 col-sm-6" v-if="transferOfOwnershipData.cpaApplicability.value == 'E' && transferOfOwnershipData.exemptionReason.value == 'AHPACO15L'">
                <div class="row form-group">
                  <float-label 
                  label="PA Policy Number*" 
                  :fixed="isFloat(transferOfOwnershipData.paPolicyNumber.value)"> 
                  <input
                  v-model="transferOfOwnershipData.paPolicyNumber.value"
                  v-evolvews="transferOfOwnershipData.paPolicyNumber"
                  type="text"
                  v-on:keydown="onlyNumber"
                  maxlength="30"
                  :class="{
                    'bgc-error-field':transferOfOwnershipData.paPolicyNumber.errorText !=='',
                  }"
                  class="form-control"
                  placeholder="PA Policy Number*"
                  />
                  </float-label>
                  <span
                    class="error-text" v-if="transferOfOwnershipData.paPolicyNumber.errorText !== ''" >
                    {{transferOfOwnershipData.paPolicyNumber.errorText}}</span>
                </div>
              </div>
              <!--PA Policy Number ends-->
              <!--PA Insurer Name starts-->
              <div class="col-lg-3 col-md-3 col-sm-6" v-if="transferOfOwnershipData.cpaApplicability.value == 'E' && transferOfOwnershipData.exemptionReason.value == 'AHPACO15L'" >
                <div class="row form-group">
                  <float-label 
                    label="PA Insurer Name*" 
                    :fixed="isFloat(transferOfOwnershipData.paInsurerName.value)">
                    <select
                      class="form-control"
                      placeholder="PA Insurer Name*"
                      :class="{
                        'bgc-error-field':transferOfOwnershipData.paInsurerName.errorText !=='',
                      }"
                      v-model="transferOfOwnershipData.paInsurerName.value"
                      v-evolvews="transferOfOwnershipData.paInsurerName"
                    >
                      <option disabled :value='null' v-if='transferOfOwnershipData.paInsurerName.value == null'>PA Insurer Name*</option>
                      <option disabled value='' v-if='transferOfOwnershipData.paInsurerName.value == ""'>PA Insurer Name*</option>
                      <option v-for="insurer in domainValues.initPreviousPolicyDetails.insuranceCompanies" :key="insurer.code" :value="insurer.code">{{insurer.name}}</option>
                    </select>
                  </float-label>
                  <span
                    class="error-text" v-if="transferOfOwnershipData.paInsurerName.errorText !== ''" >
                    {{transferOfOwnershipData.paInsurerName.errorText}}</span>
                </div>
              </div>
              <!--PA Insurer Name ends-->
              <!--PA Policy Inception Date starts-->
              <div class="col-lg-3 col-md-3 col-sm-6" v-if="transferOfOwnershipData.cpaApplicability.value == 'E' && transferOfOwnershipData.exemptionReason.value == 'AHPACO15L'" >
                <div class="row form-group">
                  <float-label label="PA Policy Inception Date*" :fixed="isFloat(transferOfOwnershipData.paPolicyInceptionDate.value)">
                    <datepicker
                      v-model="transferOfOwnershipData.paPolicyInceptionDate.value"
                      v-evolvews="transferOfOwnershipData.paPolicyInceptionDate"
                      :typeable="true"
                      format="dd/MM/yyyy"
                      placeholder="PA Policy Inception Date*"
                      :input-class="isInputError(transferOfOwnershipData.paPolicyInceptionDate.errorText)"
                      @selected="checkError(transferOfOwnershipData.paPolicyInceptionDate,false)"
                      @input="checkError(transferOfOwnershipData.paPolicyInceptionDate,false)"
                      :disabledDates="disableInceptionDate" 
                    ></datepicker>
                  </float-label>
                  <span
                class="error-text"
                v-if="transferOfOwnershipData.paPolicyInceptionDate.errorText !== ''"
                >{{transferOfOwnershipData.paPolicyInceptionDate.errorText}}</span>
                </div>
              </div>
              <!--PA Policy Inception Date ends-->
              <!--PA Policy Expiry Date starts-->
              <div class="col-lg-3 col-md-3 col-sm-6" v-if="transferOfOwnershipData.cpaApplicability.value == 'E' && transferOfOwnershipData.exemptionReason.value == 'AHPACO15L'" >
                <div class="row form-group">
                  <float-label label="PA Policy Expiry Date*" :fixed="isFloat(transferOfOwnershipData.paPolicyExpiryDate.value)">
                    <datepicker
                      v-model="transferOfOwnershipData.paPolicyExpiryDate.value"
                      v-evolvews="transferOfOwnershipData.paPolicyExpiryDate"
                      :typeable="true"
                      format="dd/MM/yyyy"
                      placeholder="PA Policy Expiry Date*"
                      :input-class="isInputError(transferOfOwnershipData.paPolicyExpiryDate.errorText)"
                      @selected="checkError(transferOfOwnershipData.paPolicyExpiryDate,false)"
                      @input="checkError(transferOfOwnershipData.paPolicyExpiryDate,false)"
                      :disabledDates="disableExpiryDate" 
                    ></datepicker>
                  </float-label>
                  <span
                class="error-text"
                v-if="transferOfOwnershipData.paPolicyExpiryDate.errorText !== ''"
                >{{transferOfOwnershipData.paPolicyExpiryDate.errorText}}</span>
                </div>
              </div>
              <!--PA Policy Expiry Date ends-->
            </div>
            <!-- Hypothecation Applicable* starts -->
            <div class="risk row col-12 d-flex pl-0">
              <label class="pr-4 mt-5">
                Hypothecation Applicable*
              </label>
              <div class="radio-status pl-1">
                <input
                  type="radio"
                  class="bgc-radio"
                  name="radiobutton"
                  v-model="transferOfOwnershipData.hypothecationApplicable.value"
                  id="hypoYes"
                  value="YES"
                  selected
                  @change="hypothecationApplicableChange()+resetHypothecationData()"
                />
                <label class="mt-3 mr-2" for="hypoYes">
                  <span>Yes</span>
                </label>
                <input
                  type="radio"
                  class="bgc-radio"
                  name="radiobutton"
                  v-model="transferOfOwnershipData.hypothecationApplicable.value"
                  id="hypoNo"
                  value="NO"
                  @change="hypothecationApplicableChange()+resetHypothecationData()"
                />
                <label class="radio-inactive mt-3 ml-4" for="hypoNo">
                  <span>No</span>
                </label>
              </div>
            </div>
            <!-- Hypothecation Applicable* ends -->
            <div class="risk row" v-if="transferOfOwnershipData.hypothecationApplicable.value=='YES'">
              <!--Hypothecation Type* starts-->
              <div class=" col-lg-3 col-md-3 col-sm-6 ">
                <div class="row form-group">
                  <float-label
                  label="Hypothecation Type*"
                  :fixed="isFloat(transferOfOwnershipData.hypothecationType.value)"
                >
                  <select
                    class="form-control"
                    placeholder="Hypothecation Type*"
                    @change="onBlurHypothecationTypeInstitute()"
                    v-model="transferOfOwnershipData.hypothecationType.value"
                    v-evolvews="transferOfOwnershipData.hypothecationType"
                    :class="{ 'bgc-error-field': transferOfOwnershipData.hypothecationType.errorText!=='' }"
                    >
                    <option disabled value='' v-if='transferOfOwnershipData.hypothecationType.value == ""'>Hypothecation Type*</option>
                    <option disabled :value='null' v-if='transferOfOwnershipData.hypothecationType.value == null'>Hypothecation Type*</option>
                    <option v-for="type in domainValues.initMotorDomainLists.hypothecationTypes" :key="type.code" :value="type.code">{{type.name}}</option>
                  </select>
                </float-label>
                <span
                  class="error-text" v-if="transferOfOwnershipData.hypothecationType.errorText !== ''" >
                  {{transferOfOwnershipData.hypothecationType.errorText}}</span>
                </div>
              </div>
              <!--Hypothecation Type ends-->
              <!--Hypothecation Institute starts-->
              <div class="col-lg-3 col-md-3 col-sm-6" v-if="transferOfOwnershipData.hypothecationApplicable.value=='YES'">
                <div class="row form-group">
                  <float-label 
                    label="Hypothecation Institute*" 
                    :fixed="isFloat(transferOfOwnershipData.hypothecationInstitute.value)"> 
                    <input
                      v-model="transferOfOwnershipData.hypothecationInstitute.value"
                      v-evolvews="transferOfOwnershipData.hypothecationInstitute"
                      type="text"
                      maxlength="30"
                      @blur="onBlurHypothecationTypeInstitute()"
                      :class="{
                        'bgc-error-field':transferOfOwnershipData.hypothecationInstitute.errorText !=='',
                      }"
                      class="form-control"
                      placeholder="Hypothecation Institute*"
                    />
                  </float-label>
                  <span
                    class="error-text" v-if="transferOfOwnershipData.hypothecationInstitute.errorText !== ''" >
                    {{transferOfOwnershipData.hypothecationInstitute.errorText}}</span>
                </div>
              </div>
              <!--Hypothecation Institute ends-->
              <!--Remarks starts-->
              <div class="col-lg-3 col-md-3 col-sm-6" v-if="transferOfOwnershipData.hypothecationApplicable.value=='YES'">
                <div class="row form-group">
                  <float-label 
                    label="Remarks" 
                    :fixed="isFloat(transferOfOwnershipData.hypothicationRemarks.value)"> 
                    <input
                      v-model="transferOfOwnershipData.hypothicationRemarks.value"
                      v-evolvews="transferOfOwnershipData.hypothicationRemarks"
                      type="text"
                      maxlength="50"
                      :class="{
                        'bgc-error-field':transferOfOwnershipData.hypothicationRemarks.errorText !=='',
                      }"
                      class="form-control"
                      placeholder="Remarks"
                    />
                  </float-label>
                  <span
                    class="error-text" v-if="transferOfOwnershipData.hypothicationRemarks.errorText !== ''" >
                    {{transferOfOwnershipData.hypothicationRemarks.errorText}}</span>
                </div>
              </div>
              <!--Remarks ends-->
            </div>
          </div>
        </div> 
      </div>
      <div v-if="transferOfOwnershipData.ncbApplicable.visibility && ((showAddParty.value && hideAddProceed ) || (!showAddParty.value)) && getSavedQuoteData.motorPolicyBasicDetails.policyType!=='LO' && 
      getSavedQuoteData.motorPolicyBasicDetails.policyType!=='LBO' && getSavedQuoteData.motorPolicyBasicDetails.policyType!=='L2' && getSavedQuoteData.motorPolicyBasicDetails.policyType!=='L3' && 
      getSavedQuoteData.motorPolicyBasicDetails.policyType!=='L5'">
        <div class="risk row" >
          <!-- NCB Applicable* starts -->
          <div class="form-group col-lg-5 col-md-5 col-sm-6 p-0">
            <div class="form-group d-flex">
              <p class="mr-5">NCB Applicable*</p>
              <input
                type="radio"
                class="input-radio bgc-radio ml-2"
                name="radiobuttonncb"
                v-model="transferOfOwnershipData.ncbApplicable.value"
                id="ncbApplicableYes"
                value="YES"
                @change="ncbApplicableChange()+resetNcbData()"
              />
              <label class="custom-control-label" for="ncbApplicableYes">
                <span>Yes</span>
              </label>
              <input
                type="radio"
                class="input-radio bgc-radio ml-5"
                name="radiobuttonncb"
                v-model="transferOfOwnershipData.ncbApplicable.value"
                id="ncbApplicableNo"
                value="NO"
                selected
                @change="ncbApplicableChange()+resetNcbData()+handleNcbRetentionCancel()"
              />
              <label class="custom-control-label" for="ncbApplicableNo">
                <span>No</span>
              </label>
            </div>
          </div>
          <!-- NCB Applicable* ends -->
        </div> 
        <div class="risk row" v-if="transferOfOwnershipData.ncbApplicable.value=='YES'">
          <!--NCB Taken from* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
              <float-label 
                label="NCB Taken From*" 
                :fixed="isFloat(transferOfOwnershipData.ncbTakenFrom.value)">
                <select
                :class="{
                  'bgc-error-field':transferOfOwnershipData.ncbTakenFrom.errorText !=='',
                  }"
                  class="form-control"
                  placeholder="NCB Taken From*"
                  v-model="transferOfOwnershipData.ncbTakenFrom.value"
                  v-evolvews="transferOfOwnershipData.ncbTakenFrom"
                >
                <option disabled :value='null' v-if='transferOfOwnershipData.ncbTakenFrom.value == null'>NCB Taken From*</option>
                <option disabled value=''  v-if='transferOfOwnershipData.ncbTakenFrom.value == ""'>NCB Taken From*</option>
                <option v-for="ncbtaken in previousPolicyDetailsObj.ncbTakenFrom" :key="ncbtaken.code" :value="ncbtaken.code">{{ncbtaken.name}}</option>
                </select>
              </float-label>
              <span
                class="error-text" v-if="transferOfOwnershipData.ncbTakenFrom.errorText !== ''" >
                {{transferOfOwnershipData.ncbTakenFrom.errorText}}</span>
            </div>
          </div>
          <!--NCB Taken from* ends-->
          <!--Applicable NCB %* starts-->
          <div class="col-lg-3 col-md-3 col-sm-6">
            <div class="row form-group">
              <float-label 
                label="Applicable NCB %*" 
                :fixed="isFloat(transferOfOwnershipData.currentYearNcb.value)"> 
                <select
                v-model="transferOfOwnershipData.currentYearNcb.value"
                v-evolvews="transferOfOwnershipData.currentYearNcb"
                type="text"
                :class="{
                  'bgc-error-field':transferOfOwnershipData.currentYearNcb.errorText !=='',
                }"
                class="form-control"
                placeholder="Applicable NCB %*"
                :disabled="transferOfOwnershipData.vehicleTransferredToWhom.value=='LH'"
                @change="handleNcbRetentionModal()"
                >
                <option disabled selected value="" v-if="transferOfOwnershipData.currentYearNcb.value==''">Applicable NCB%*</option>
                <option disabled selected :value='null' v-if="transferOfOwnershipData.currentYearNcb.value==null">Applicable NCB%*</option>
                <option value="0">0</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="35">35</option>
                <option value="45">45</option>
                <option value="50">50</option>
                </select>
              </float-label>
              <span
                class="error-text" v-if="transferOfOwnershipData.currentYearNcb.errorText !== ''" >
                {{transferOfOwnershipData.currentYearNcb.errorText}}</span>
            </div>
          </div> 
          <!--Applicable NCB %* ends-->
        </div>
      </div> 
      <div v-if="showNcbRetentionField.value && transferOfOwnershipData.ncbApplicable.visibility && ((showAddParty.value && hideAddProceed ) || (!showAddParty.value)) && transferOfOwnershipData.ncbApplicable.value=='YES'">
          <div class="risk row mt-3">
              <p class="font-weight-bold">NCB Retention Certificate Details</p>
          </div>
          <div class="risk row">
            <!--Registration Number starts-->
            <div class="form-group col-lg-3 col-md-3 col-sm-6 col-6 p-0 mt-0" >
              <div class="col-6 pl-0">
                <RegNumSearch :regNumError="state.regNumErrorText" :registrationData="transferOfOwnershipData.ncbRegistrationNumber" @setvehicledetails="setRegData"></RegNumSearch>
              </div>
            </div>
            <!--Registration Number ends-->
          </div>
          <div class="risk row">
            <!--Engine Number as per NCB Retention* starts -->
            <div class="col-lg-3 col-md-3 col-sm-6" >
              <div class="row form-group">
                <float-label label="Engine Number*" :fixed="isFloat(transferOfOwnershipData.ncbEngineNumber.value)"> 
                  <input
                    v-model="transferOfOwnershipData.ncbEngineNumber.value"
                    v-evolvews="transferOfOwnershipData.ncbEngineNumber"
                    type="text"
                    maxlength="20"
                    v-on:keydown="alphaNumeric"
                    :class="{'bgc-error-field':transferOfOwnershipData.ncbEngineNumber.errorText !== '',}"
                    placeholder="Engine Number*"
                    class="form-control engine-input"
                  />
                </float-label>
                  <span class="error-text" v-if="transferOfOwnershipData.ncbEngineNumber.errorText !== ''">
                    {{transferOfOwnershipData.ncbEngineNumber.errorText}}</span>
              </div>
            </div>
            <!--Engine Number as per NCB Retention* ends-->
            <!--Chassis Number as per NCB Retention* v-if="transferOfOwnershipData.ncbChassisNo.visibility" starts-->
            <div class="col-lg-3 col-md-3 col-sm-6" >
              <div class="row form-group">
                <float-label label="Chassis Number*" :fixed="isFloat(transferOfOwnershipData.ncbChassisNo.value)"> 
                  <input
                    v-model="transferOfOwnershipData.ncbChassisNo.value"
                    v-evolvews="transferOfOwnershipData.ncbChassisNo"
                    type="text"
                    class="form-control chassis-input"
                    v-on:keydown="alphaNumeric"
                    maxLength="30"
                    :class="{'bgc-error-field':transferOfOwnershipData.ncbChassisNo.errorText !== '',}"
                    placeholder="Chassis Number*"
                  />
                </float-label>
                  <span class="error-text" v-if="transferOfOwnershipData.ncbChassisNo.errorText !== ''">
                    {{transferOfOwnershipData.ncbChassisNo.errorText}}</span>
              </div>
            </div>
            <!--Chassis Number as per NCB Retention* ends-->
            <!--Previous Policy Number as per NCB Retention* starts-->
              <div class="col-lg-3 col-md-3 col-sm-6" >
                <div class="row form-group">
                  <float-label label="Previous Policy Number*" :fixed="isFloat(transferOfOwnershipData.ncbPreviousPolicyNumber.value)"> 
                    <input
                      v-model="transferOfOwnershipData.ncbPreviousPolicyNumber.value"
                      v-evolvews="transferOfOwnershipData.ncbPreviousPolicyNumber"
                      type="text"
                      maxlength="50"
                      v-on:keydown="alphaNumeric"
                      :class="{'bgc-error-field':transferOfOwnershipData.ncbPreviousPolicyNumber.errorText !== '',}"
                      class="form-control"
                      placeholder="Previous Policy Number*"
                    />
                  </float-label>
                  <span class="error-text" v-if="transferOfOwnershipData.ncbPreviousPolicyNumber.errorText !== ''">
                    {{transferOfOwnershipData.ncbPreviousPolicyNumber.errorText}}</span>
                </div>
              </div>
            <!--Previous Policy Number as per NCB Retention* ends-->
            <!-- Retention Letter Effective Date* starts-->
            <div class="col-lg-3 col-md-3 col-sm-6">
              <div class="row form-group">
                <float-label 
                  label="Retention Letter Effective Date*" 
                  :fixed="isFloat(transferOfOwnershipData.ncbRetentionLetterEffectiveDate.value)">
                  <datepicker
                    v-model="transferOfOwnershipData.ncbRetentionLetterEffectiveDate.value"
                    v-evolvews="transferOfOwnershipData.ncbRetentionLetterEffectiveDate"
                    :typeable="true"
                    format="dd/MM/yyyy"
                    placeholder="Retention Letter Effective Date*"
                    :input-class="isInputError(transferOfOwnershipData.ncbRetentionLetterEffectiveDate.errorText)"
                    @selected="checkError(transferOfOwnershipData.ncbRetentionLetterEffectiveDate,false)"
                    @input="checkError(transferOfOwnershipData.ncbRetentionLetterEffectiveDate,false)"
                  ></datepicker>
                </float-label>
                <span
              class="error-text"
              v-if="transferOfOwnershipData.ncbRetentionLetterEffectiveDate.errorText !== ''"
              >{{transferOfOwnershipData.ncbRetentionLetterEffectiveDate.errorText}}</span>
              </div>
            </div>
            <!--Retention Letter Effective Date* ends--> 
          </div>
      </div>
    </div>
    <AdvanceSearchParty :showModal="state.showModal" :partyType="transferOfOwnershipData.partyType.value" />
    <ncbRetentionModal :showNcbRetentionModal="state.showNcbRetentionModal" />
  </div>
</template>

<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import Datepicker from "vuejs-datepicker";
import functions from "@/../../masters/functions.js";
import AdvanceSearchParty from "../modals/AdvanceSearchParty.vue"
import CorrespondenceAddress from "./CorrespondenceAddress.vue";
import RegNumSearch from "@/../../shared_motor_component/RegNumSearch.vue";
import ncbRetentionModal from "../modals/ncbRetentionModal";
import moment from "moment";
import { reactive, onUpdated, onMounted, computed, watch} from "@vue/composition-api";
export default {
  name: "TransferOfOwnership",
  props: ["transferOfOwnershipData", "previousPolicyDetailsObj",'panNameStatus','panValidate', 'validateGstLoader','gstNameStatus','validatePanLoader',
  "validationSuccess","getSavedQuoteData","showAddParty","switchParty","checkPartyStatus","pageMounted","hideAddProceed","selectedEndrsType","searchPartyData","domainValues",
  "cpaDurationList","areas","permanentAreas","searchPartyLoader","partyType","isCpaMandatory","showNcbRetentionField","vehicleTransferDataArr"],
  components: {
    Datepicker,
    FloatLabel,
    AdvanceSearchParty,
    CorrespondenceAddress,
    ncbRetentionModal,
    RegNumSearch
  },
  setup(props,context) {
    let state = reactive({
      exemptionReasonsList: [],
      transferOfOwnershipDataArr : [],
      showModal: false,
      showNcbRetentionModal:false,
      showncbmodal:false,
      regNumErrorText: false,
      // showSearchParty: false,
      // showAddParty: true,
      // switchParty: 'motor-party',
      titleArray : [{
          name: "Mr.",
          code: "MR"
        },
        {
          name: "Mrs.",
          code: "MRS"
        },
        {
          name: "Ms.",
          code: "MS"
        }]
    });
    onMounted(()=>{
      if(props.pageMounted.value){ 
        changePartyType();
        switchAddparty('showAddParty');
        // props.showAddParty.value = true;
      }
      else{
        setExemptionReasons();
      }
      props.pageMounted.value = false;
      props.transferOfOwnershipData.ncbRegistrationNumber.values = ['', '', '', ''];
      props.transferOfOwnershipData.ncbRegistrationNumber.value = '';
      getVehicleTransferToWhomDomainList();
    });
    onUpdated(()=>{
      // state.transferOfOwnershipDataArr = Object.keys(props.transferOfOwnershipData).map(attr =>{
      //   return (props.transferOfOwnershipData[attr].value);
      // });
      context.parent.calculateSteps();
      context.parent.enableCalculatePremiumBtn('transferOfOwnership');
    });
    // function enableCalculatePremiumBtn(endorsementType){
    //   context.parent.enableCalculatePremiumBtn(endorsementType);
    // }
    function calculateSteps(){
      context.parent.calculateSteps();
    }
    function validatePan(){
      context.parent.validatePan('transferOwnership');
    }
    function resetPanText(){
      context.parent.resetPanText();
    }
    function validateProgressBar(){
      for(let section in props.transferOfOwnershipData){
        if(section != 'correspondenceAddress' && section != 'permanentAddress' && section !='hidePermanentAddress'){
          let currAttr = props.transferOfOwnershipData[section];
          if(!props.showAddParty.value){
            if(!currAttr.hasOwnProperty('visibleInSearchParty')){
              context.root.$set(currAttr,'stepsMandatory',false);
              context.root.$set(currAttr,'skip',true);
              context.root.$set(props.transferOfOwnershipData.cpaApplicability,'stepsMandatory',true);
              delete props.transferOfOwnershipData.cpaApplicability.skip;
              setExemptionReasons();
              hypothecationApplicableChange();
              ncbApplicableChange();
            }
          }else{
            if(currAttr.hasOwnProperty('ownerDetailsVisibility')){
              context.root.$set(currAttr,'stepsMandatory',false);
              context.root.$set(currAttr,'skip',true);
            }
            changePartyType();
          }
        }
      }
    }
    function getVehicleTransferToWhomDomainList(){
      context.parent.getVehicleTransferToWhomDomainList();
    }
    function onlyNumberMotor(e,targetObj){
      context.parent.onlyNumberMotor(e,targetObj);
    }
    function onChangeVehicleTransferred(){
      if(props.transferOfOwnershipData.vehicleTransferredToWhom.value && props.transferOfOwnershipData.vehicleTransferredToWhom.value !== 'LH'){
        props.transferOfOwnershipData.currentYearNcb.value = 0;
        props.transferOfOwnershipData.currentYearNcb.oldValue = 0;
        context.parent.handleNcbRetentionFlag(false);
      }
    }
    function handleNcbRetentionModal(){
      if(!state.showncbmodal && props.transferOfOwnershipData.currentYearNcb.value>0){
        state.showNcbRetentionModal = true;
        state.showncbmodal = true;
      }
    }
    function closeNcbRetentionModal(){
      state.showNcbRetentionModal = false;
    }
    function handleNcbRetentionProceed(){
      props.showNcbRetentionField.value = true;
      setTimeout(()=>{
        closeNcbRetentionModal();
      },500);
      context.root.$set(props.transferOfOwnershipData.ncbPreviousPolicyNumber, 'stepsMandatory', true);
      delete props.transferOfOwnershipData.ncbPreviousPolicyNumber.skip;
      context.root.$set(props.transferOfOwnershipData.ncbEngineNumber, 'stepsMandatory', true);
      delete props.transferOfOwnershipData.ncbEngineNumber.skip;
      context.root.$set(props.transferOfOwnershipData.ncbChassisNo, 'stepsMandatory', true);
      delete props.transferOfOwnershipData.ncbChassisNo.skip;
      context.root.$set(props.transferOfOwnershipData.ncbRegistrationNumber, 'stepsMandatory', true);
      delete props.transferOfOwnershipData.ncbRegistrationNumber.skip;
      context.root.$set(props.transferOfOwnershipData.ncbRetentionLetterEffectiveDate, 'stepsMandatory', true);
      delete props.transferOfOwnershipData.ncbRetentionLetterEffectiveDate.skip;
      props.transferOfOwnershipData.ncbPreviousPolicyNumber.errorText = '';
      props.transferOfOwnershipData.ncbEngineNumber.errorText = '';
      props.transferOfOwnershipData.ncbChassisNo.errorText = '';
      props.transferOfOwnershipData.ncbRegistrationNumber.errorText = '';
      props.transferOfOwnershipData.ncbRetentionLetterEffectiveDate.errorText = '';
      state.regNumErrorText = true;
      //mapExistingVehicleData();
      context.parent.handleNcbRetentionFlag(true);
    }
    function handleNcbRetentionCancel(){
      state.showncbmodal = false;
      state.regNumErrorText = false;
      closeNcbRetentionModal();
      props.showNcbRetentionField.value = false;
      props.transferOfOwnershipData.currentYearNcb.value = 0;
      props.transferOfOwnershipData.currentYearNcb.oldValue = 0;
      context.root.$set(props.transferOfOwnershipData.ncbPreviousPolicyNumber, 'stepsMandatory', false);
      context.root.$set(props.transferOfOwnershipData.ncbPreviousPolicyNumber, 'skip', true);
      context.root.$set(props.transferOfOwnershipData.ncbEngineNumber, 'stepsMandatory', false);
      context.root.$set(props.transferOfOwnershipData.ncbEngineNumber, 'skip', true);
      context.root.$set(props.transferOfOwnershipData.ncbChassisNo, 'stepsMandatory', false);
      context.root.$set(props.transferOfOwnershipData.ncbChassisNo, 'skip', true);
      context.root.$set(props.transferOfOwnershipData.ncbRegistrationNumber, 'stepsMandatory', false);
      context.root.$set(props.transferOfOwnershipData.ncbRegistrationNumber, 'skip', true);
      context.root.$set(props.transferOfOwnershipData.ncbRetentionLetterEffectiveDate, 'stepsMandatory', false);
      context.root.$set(props.transferOfOwnershipData.ncbRetentionLetterEffectiveDate, 'skip', true);
      context.parent.handleNcbRetentionFlag(false);
    }
    // function mapExistingVehicleData(){
    //   props.transferOfOwnershipData.ncbRegistrationNumber.values[0] = props.getSavedQuoteData.riskDetails.registrationNumberBox1;
    //   props.transferOfOwnershipData.ncbRegistrationNumber.values[1] = props.getSavedQuoteData.riskDetails.registrationNumberBox2;
    //   props.transferOfOwnershipData.ncbRegistrationNumber.values[2] = props.getSavedQuoteData.riskDetails.registrationNumberBox3;
    //   props.transferOfOwnershipData.ncbRegistrationNumber.values[3] = props.getSavedQuoteData.riskDetails.registrationNumberBox4;
    //   props.transferOfOwnershipData.ncbRegistrationNumber.value = props.getSavedQuoteData.riskDetails.registrationNumber;
    //   props.transferOfOwnershipData.ncbPreviousPolicyNumber.value = props.getSavedQuoteData.motorPolicyBasicDetails.previousPolicyNumber;
    //   props.transferOfOwnershipData.ncbChassisNo.value = props.getSavedQuoteData.riskDetails.chassisNo;
    //   props.transferOfOwnershipData.ncbEngineNumber.value = props.getSavedQuoteData.riskDetails.engineNumber;
    // }
    function setRegData(e){
      if(props.transferOfOwnershipData.ncbRegistrationNumber.errorText ==''){
        if(props.transferOfOwnershipData.ncbRegistrationNumber.values.filter((val, index)=> index!==2).every(val=> val!=='') && props.transferOfOwnershipData.ncbRegistrationNumber.value!=='NEW'){
          props.transferOfOwnershipData.ncbRegistrationNumber.value = props.transferOfOwnershipData.ncbRegistrationNumber.values[2] ? props.transferOfOwnershipData.ncbRegistrationNumber.values.join('-') : props.transferOfOwnershipData.ncbRegistrationNumber.values[0]+
            '-'+props.transferOfOwnershipData.ncbRegistrationNumber.values[1]+'-'+props.transferOfOwnershipData.ncbRegistrationNumber.values[3];
        }else if(props.transferOfOwnershipData.ncbRegistrationNumber.value=='NEW' && props.transferOfOwnershipData.ncbRegistrationNumber.values[0]=='' &&
          props.transferOfOwnershipData.ncbRegistrationNumber.values[1]==''){
          props.transferOfOwnershipData.ncbRegistrationNumber.value = '';
        }
      }
      if(/[0-9]{2}/.test(props.transferOfOwnershipData.ncbRegistrationNumber.values[0]) && props.transferOfOwnershipData.ncbRegistrationNumber.values[1] == 'BH'){
        if(props.transferOfOwnershipData.ncbRegistrationNumber.values.every(val=> val != "") && !props.transferOfOwnershipData.ncbRegistrationNumber.errorText){
          props.transferOfOwnershipData.ncbRegistrationNumber.value = props.transferOfOwnershipData.ncbRegistrationNumber.values.join('-');
          props.transferOfOwnershipData.ncbRegistrationNumber.errorText = "";
        }
      }
    }
    function getSumInsured(calledFrom){
      if(calledFrom == 'cpaApplicability'){
        if(props.transferOfOwnershipData.cpaApplicability.value == 'S')
          context.parent.getSumInsured(undefined);
      }
      else{
        context.parent.getSumInsured(props.transferOfOwnershipData.cpaDuration.value);
      }
    }
    function validateRegBusiness(){
      //for business type organisation
        if(props.transferOfOwnershipData.registeredBusiness.value){
          context.root.$set(props.transferOfOwnershipData.businessRegistrationNumber, 'stepsMandatory', true)
          delete props.transferOfOwnershipData.businessRegistrationNumber.skip
          context.root.$set(props.transferOfOwnershipData.businessRegistrationDate, 'stepsMandatory', true)
          delete props.transferOfOwnershipData.businessRegistrationDate.skip
        }else{
          context.root.$set(props.transferOfOwnershipData.businessRegistrationNumber, 'stepsMandatory', false)
          context.root.$set(props.transferOfOwnershipData.businessRegistrationNumber, 'skip', true)
          context.root.$set(props.transferOfOwnershipData.businessRegistrationDate, 'stepsMandatory', false)
          context.root.$set(props.transferOfOwnershipData.businessRegistrationDate, 'skip', true)
          props.transferOfOwnershipData.businessRegistrationDate.errorText = '';
          props.transferOfOwnershipData.businessRegistrationNumber.errorText = '';
        }
    }
    function changeGstValidation(){
      // for gst part
        if(props.transferOfOwnershipData.gstRegnStatus.value){
          if(props.transferOfOwnershipData.gstRegnStatus.value=='PROVREG'){
            context.root.$set(props.transferOfOwnershipData.gstNumber, 'stepsMandatory', false);
            context.root.$set(props.transferOfOwnershipData.gstNumber, 'skip', true);
            context.root.$set(props.transferOfOwnershipData.gstIssuanceDate, 'stepsMandatory', false);
            context.root.$set(props.transferOfOwnershipData.gstIssuanceDate, 'skip', true);
            props.transferOfOwnershipData.gstIssuanceDate.errorText = '';
            props.transferOfOwnershipData.gstNumber.errorText = '';
          }else{
            context.root.$set(props.transferOfOwnershipData.gstNumber, 'stepsMandatory', true);
            context.root.$set(props.transferOfOwnershipData.gstNumber, 'skip', undefined);
            context.root.$set(props.transferOfOwnershipData.gstIssuanceDate, 'stepsMandatory', true);
            context.root.$set(props.transferOfOwnershipData.gstIssuanceDate, 'skip', undefined);
          }
        }else{
          context.root.$set(props.transferOfOwnershipData.gstNumber, 'stepsMandatory', false);
          context.root.$set(props.transferOfOwnershipData.gstNumber, 'skip', true);
          context.root.$set(props.transferOfOwnershipData.gstIssuanceDate, 'stepsMandatory', false);
          context.root.$set(props.transferOfOwnershipData.gstIssuanceDate, 'skip', true);
        }

    }
    function changePartyType(){
      props.transferOfOwnershipData.gstRegnStatus.value = '';
      if(props.showAddParty.value){
        if(props.transferOfOwnershipData.partyType.value == 'I'){
          props.transferOfOwnershipData.cpaApplicability.value = props.transferOfOwnershipData.cpaApplicability.oldValue;
          context.root.$set(props.transferOfOwnershipData.title,'stepsMandatory',true);
          context.root.$set(props.transferOfOwnershipData.firstName,'stepsMandatory', true);
          context.root.$set(props.transferOfOwnershipData.lastName,'stepsMandatory', true);
          delete props.transferOfOwnershipData.title.skip;
          delete props.transferOfOwnershipData.firstName.skip;
          delete props.transferOfOwnershipData.lastName.skip;
          // for org part
          context.root.$set(props.transferOfOwnershipData.businessRegistrationNumber, 'stepsMandatory', false);
          context.root.$set(props.transferOfOwnershipData.businessRegistrationNumber, 'skip', true);
          context.root.$set(props.transferOfOwnershipData.businessRegistrationDate, 'stepsMandatory', false);
          context.root.$set(props.transferOfOwnershipData.businessRegistrationDate, 'skip', true);
          context.root.$set(props.transferOfOwnershipData.organizationName, 'stepsMandatory', false);
          context.root.$set(props.transferOfOwnershipData.organizationName, 'skip', true);
          // for gst part
          context.root.$set(props.transferOfOwnershipData.gstNumber, 'stepsMandatory', false);
          context.root.$set(props.transferOfOwnershipData.gstNumber, 'skip', true);
          context.root.$set(props.transferOfOwnershipData.gstIssuanceDate, 'stepsMandatory', false);
          context.root.$set(props.transferOfOwnershipData.gstIssuanceDate, 'skip', true);
        }else{
          props.transferOfOwnershipData.registeredBusiness.value = false;
          context.root.$set(props.transferOfOwnershipData.title,'stepsMandatory',false);
          context.root.$set(props.transferOfOwnershipData.firstName,'stepsMandatory', false);
          context.root.$set(props.transferOfOwnershipData.lastName,'stepsMandatory', false);
          context.root.$set(props.transferOfOwnershipData.title,'skip',true);
          context.root.$set(props.transferOfOwnershipData.firstName,'skip', true);
          context.root.$set(props.transferOfOwnershipData.lastName,'skip', true);
          context.root.$set(props.transferOfOwnershipData.organizationName, 'stepsMandatory', true);
          delete props.transferOfOwnershipData.organizationName.skip;
          props.transferOfOwnershipData.cpaApplicability.value = 'E';
          setExemptionReasons();
        }
      }
      else{
        validateProgressBar();
        if(props.transferOfOwnershipData.partyType.value == 'I'){
          props.transferOfOwnershipData.cpaApplicability.value = props.transferOfOwnershipData.cpaApplicability.oldValue;
        }
        else{
          props.transferOfOwnershipData.cpaApplicability.value = 'E';
          setExemptionReasons();
        }
      }
    }
    function switchAddparty(calledFrom){
      context.parent.resetAddProceedBtn(calledFrom);
      props.transferOfOwnershipData.partyType.value = props.transferOfOwnershipData.partyType.oldValue;
      props.transferOfOwnershipData.cpaApplicability.value = props.transferOfOwnershipData.cpaApplicability.oldValue;
      if(calledFrom == 'showSearchParty'){
        setExemptionReasons();
        hypothecationApplicableChange();
        ncbApplicableChange();
        // state.showSearchParty = true;
        props.showAddParty.value = false;
        // context.root.$set(props.transferOfOwnershipData.partyType,'stepsMandatory',false);
        // context.root.$set(props.transferOfOwnershipData.partyType,'skip',true);
        delete props.transferOfOwnershipData.partyId.skip;
        context.root.$set(props.transferOfOwnershipData.partyId,'stepsMandatory',true);
      }
      if(calledFrom == 'showAddParty'){
        props.showAddParty.value = true;
        // state.showSearchParty = false;
        context.root.$set(props.transferOfOwnershipData.partyId,'stepsMandatory',false);
        context.root.$set(props.transferOfOwnershipData.partyId,'skip',true);
        props.transferOfOwnershipData.exemptionReason.value = props.transferOfOwnershipData.exemptionReason.oldValue;
        resetPAPolicyData();
        checkExemption();
        // delete props.transferOfOwnershipData.partyType.skip;
        // context.root.$set(props.transferOfOwnershipData.partyType,'stepsMandatory',true);
      }
      validateProgressBar();
      context.parent.calculateSteps();
    }
    function getAreaDetailsByPinCode(calledFrom,addressDetail){
      context.parent.getAreaDetailsByPinCode(calledFrom,addressDetail);
    }
    function setExemptionReasons(){
      state.exemptionReasonsList = JSON.parse(JSON.stringify(props.domainValues.initMotorDomainLists.exemptionReasons));
      if(props.transferOfOwnershipData.cpaApplicability.value == 'E'){
        if(props.transferOfOwnershipData.partyType.value == 'O'){
          props.transferOfOwnershipData.exemptionReason.value = 'I'
        }
        else{
          state.exemptionReasonsList = props.domainValues.initMotorDomainLists.exemptionReasons.filter(exemptionReason=>{
            return exemptionReason.code != 'I';
          });
        }
        context.root.$set(props.transferOfOwnershipData.exemptionReason,'stepsMandatory',true);
        delete props.transferOfOwnershipData.exemptionReason.skip;
      }
      else{
        // context.root.$set(props.transferOfOwnershipData.exemptionReason,'stepsMandatory',false);
        delete props.transferOfOwnershipData.exemptionReason.stepsMandatory;
        context.root.$set(props.transferOfOwnershipData.exemptionReason,'skip',true);
      }
      if(props.transferOfOwnershipData.cpaApplicability.value == 'C'){
        context.root.$set(props.transferOfOwnershipData.cpaDuration,'stepsMandatory',true);
        delete props.transferOfOwnershipData.cpaDuration.skip;
      }
      else{
        delete props.transferOfOwnershipData.cpaDuration.stepsMandatory;
        context.root.$set(props.transferOfOwnershipData.cpaDuration,'skip',true);
      }
      checkExemption();
    }
    function hypothecationApplicableChange(){
      if(props.transferOfOwnershipData.hypothecationApplicable.value == 'NO'){
        context.root.$set(props.transferOfOwnershipData.hypothecationType,'stepsMandatory', false);
        context.root.$set(props.transferOfOwnershipData.hypothecationType,'skip', true);
        context.root.$set(props.transferOfOwnershipData.hypothecationInstitute,'stepsMandatory', false);
        context.root.$set(props.transferOfOwnershipData.hypothecationInstitute,'skip', true);
      }
      else{
        context.root.$set(props.transferOfOwnershipData.hypothecationType,'stepsMandatory', true);
        delete props.transferOfOwnershipData.hypothecationType.skip;
        context.root.$set(props.transferOfOwnershipData.hypothecationInstitute,'stepsMandatory', true);
        delete props.transferOfOwnershipData.hypothecationInstitute.skip;
      }
    }
    function ncbApplicableChange(){
      if(props.transferOfOwnershipData.ncbApplicable.value == 'YES'){
        context.root.$set(props.transferOfOwnershipData.ncbTakenFrom,'stepsMandatory', true);
        delete props.transferOfOwnershipData.ncbTakenFrom.skip;
        context.root.$set(props.transferOfOwnershipData.currentYearNcb,'stepsMandatory', true);
        delete props.transferOfOwnershipData.currentYearNcb.skip;
      }
      else{
        context.root.$set(props.transferOfOwnershipData.ncbTakenFrom,'stepsMandatory', false);
        context.root.$set(props.transferOfOwnershipData.ncbTakenFrom,'skip', true);
        context.root.$set(props.transferOfOwnershipData.currentYearNcb,'stepsMandatory', false);
        context.root.$set(props.transferOfOwnershipData.currentYearNcb,'skip', true);
      } 
    }
    function resetData(){
      props.transferOfOwnershipData.exemptionReason.errorText = '';
      props.transferOfOwnershipData.cpaDuration.errorText = '';
      props.transferOfOwnershipData.paPolicyNumber.errorText = '';
      props.transferOfOwnershipData.paInsurerName.errorText = '';
      props.transferOfOwnershipData.paPolicyInceptionDate.errorText = '';
      props.transferOfOwnershipData.paPolicyExpiryDate.errorText = '';
      props.transferOfOwnershipData.cpaDuration.value = props.transferOfOwnershipData.cpaDuration.oldValue;
      props.transferOfOwnershipData.paNomineeName.value = props.transferOfOwnershipData.paNomineeName.oldValue;
      props.transferOfOwnershipData.paNomineeRelation.value = props.transferOfOwnershipData.paNomineeRelation.oldValue;
      props.transferOfOwnershipData.exemptionReason.value = props.transferOfOwnershipData.exemptionReason.oldValue;
      props.transferOfOwnershipData.paPolicyNumber.value = props.transferOfOwnershipData.paPolicyNumber.oldValue;
      props.transferOfOwnershipData.paInsurerName.value = props.transferOfOwnershipData.paInsurerName.oldValue;
      props.transferOfOwnershipData.paPolicyInceptionDate.value = props.transferOfOwnershipData.paPolicyInceptionDate.oldValue;
      props.transferOfOwnershipData.paPolicyExpiryDate.value = props.transferOfOwnershipData.paPolicyExpiryDate.oldValue;
    }
    function checkExemption(){
      if(props.transferOfOwnershipData.cpaApplicability.value == 'E' && props.transferOfOwnershipData.exemptionReason.value == 'AHPACO15L'){
        context.root.$set(props.transferOfOwnershipData.paPolicyNumber,'stepsMandatory', true);
        context.root.$set(props.transferOfOwnershipData.paInsurerName,'stepsMandatory', true);
        context.root.$set(props.transferOfOwnershipData.paPolicyInceptionDate,'stepsMandatory', true);
        context.root.$set(props.transferOfOwnershipData.paPolicyExpiryDate,'stepsMandatory', true);
        delete props.transferOfOwnershipData.paPolicyNumber.skip;
        delete props.transferOfOwnershipData.paInsurerName.skip;
        delete props.transferOfOwnershipData.paPolicyInceptionDate.skip;
        delete props.transferOfOwnershipData.paPolicyExpiryDate.skip;
      }
      else{
        context.root.$set(props.transferOfOwnershipData.paPolicyNumber,'skip', true);
        context.root.$set(props.transferOfOwnershipData.paInsurerName,'skip', true);
        context.root.$set(props.transferOfOwnershipData.paPolicyInceptionDate,'skip', true);
        context.root.$set(props.transferOfOwnershipData.paPolicyExpiryDate,'skip', true);
        delete props.transferOfOwnershipData.paPolicyNumber.stepsMandatory;
        delete props.transferOfOwnershipData.paInsurerName.stepsMandatory;
        delete props.transferOfOwnershipData.paPolicyInceptionDate.stepsMandatory;
        delete props.transferOfOwnershipData.paPolicyExpiryDate.stepsMandatory;
      }
    }
    function resetPAPolicyData(){
      props.transferOfOwnershipData.exemptionReason.errorText = '';
      props.transferOfOwnershipData.paPolicyNumber.value = props.transferOfOwnershipData.paPolicyNumber.oldValue;
      props.transferOfOwnershipData.paPolicyNumber.errorText = '';
      props.transferOfOwnershipData.paInsurerName.value = props.transferOfOwnershipData.paInsurerName.oldValue;
      props.transferOfOwnershipData.paInsurerName.errorText = '';
      props.transferOfOwnershipData.paPolicyInceptionDate.value = props.transferOfOwnershipData.paPolicyInceptionDate.oldValue;
      props.transferOfOwnershipData.paPolicyInceptionDate.errorText = '';
      props.transferOfOwnershipData.paPolicyExpiryDate.value = props.transferOfOwnershipData.paPolicyExpiryDate.oldValue;
      props.transferOfOwnershipData.paPolicyExpiryDate.errorText = '';
    }
    function onBlurHypothecationTypeInstitute(){
      if(!props.transferOfOwnershipData.hypothecationType.value && props.transferOfOwnershipData.hypothecationInstitute.value){
        context.root.$set(props.transferOfOwnershipData.hypothecationType,'errorText',props.transferOfOwnershipData.hypothecationType.errorTypeMandatoryCheck);
      }else{
        context.root.$set(props.transferOfOwnershipData.hypothecationType,'errorText','');
      }
    }
    function resetHypothecationData(){
      props.transferOfOwnershipData.hypothecationType.value = props.transferOfOwnershipData.hypothecationType.oldValue;
      props.transferOfOwnershipData.hypothecationInstitute.value = props.transferOfOwnershipData.hypothecationInstitute.oldValue;
      props.transferOfOwnershipData.hypothicationRemarks.value = props.transferOfOwnershipData.hypothicationRemarks.oldValue;
    }
    function resetNcbData(){
      props.transferOfOwnershipData.ncbTakenFrom.value = props.transferOfOwnershipData.ncbTakenFrom.oldValue;
      props.transferOfOwnershipData.currentYearNcb.value = props.transferOfOwnershipData.currentYearNcb.oldValue;
    }
    function callSearchParty(){
      context.parent.callSearchParty(props.transferOfOwnershipData.partyId.value);
    }
    function closeModal(selectedParty){
      if(selectedParty){
        props.transferOfOwnershipData.partyId.value=selectedParty.partyId;
      }
      state.showModal = false;
    }
    function toUpperCase(){
      props.transferOfOwnershipData.gstNumber.value=props.transferOfOwnershipData.gstNumber.value.toUpperCase();
    }
    function validateGstUsingPAN(){
      if(props.transferOfOwnershipData.gstNumber.value && !props.transferOfOwnershipData.gstNumber.errorText){
        let extractedPan = props.transferOfOwnershipData.gstNumber.value.substring(2,12);
        context.parent.validatePan('transferOwnership',extractedPan, true);
      }
    }
    const disableInceptionDate= computed(()=>{
      return {
        from: moment(new Date()).add(1,'d').startOf('day').toDate()
      }
    });
    const disableExpiryDate= computed(()=>{
      return {
        to: moment(new Date()).subtract(1,'d').toDate()
      }
    });
    const validateDate = computed(()=>{
      return{
        from:  new Date()
      }
    })
    watch(() => props.hideAddProceed, () => {
      if(props.hideAddProceed){
        context.root.$set(props.transferOfOwnershipData.cpaApplicability,'stepsMandatory',true);
        delete props.transferOfOwnershipData.cpaApplicability.skip;
        setExemptionReasons();
        hypothecationApplicableChange();
        ncbApplicableChange();
        if(props.transferOfOwnershipData.ncbTakenFrom.hasOwnProperty('visibility') && props.transferOfOwnershipData.ncbTakenFrom.visibility){
          if((props.getSavedQuoteData.motorPolicyBasicDetails.ncbTakenFrom || props.getSavedQuoteData.motorPolicyBasicDetails.currentYearNcb)){
            props.transferOfOwnershipData.ncbApplicable.value='YES';
          }else{
            props.transferOfOwnershipData.ncbApplicable.value='NO';
          }
        }
      }
    });
    const isFloat=functions.isFloat
    const checkError = functions.checkError;
    const isInputError = functions.isInputError;
    const onlyNumber =  functions.onlyNumber;
    const alphaNumeric =  functions.alphaNumeric;
    const onlyCharSpace =  functions.onlyCharSpace;
    const onlyChar =  functions.onlyChar;
    const addressOnly = functions.addressOnly;
    const alphaNumericSpace= functions.alphaNumericSpace;
    return {
      state,
      isFloat,
      checkError,
      isInputError,
      validateGstUsingPAN,
      onlyNumber,
      onlyChar,
      toUpperCase,
      alphaNumeric,
      onlyCharSpace,
      alphaNumericSpace,
      checkExemption,
      addressOnly,
      setExemptionReasons,
      ncbApplicableChange,
      resetNcbData,
      hypothecationApplicableChange,
      onBlurHypothecationTypeInstitute,
      validatePan,
      disableInceptionDate,
      disableExpiryDate,
      resetData,
      resetPanText,
      resetPAPolicyData,
      resetHypothecationData,
      switchAddparty,
      getAreaDetailsByPinCode,
      onChangeVehicleTransferred,
      closeModal,
      changePartyType,
      calculateSteps,
      callSearchParty,
      validateDate,
      onlyNumberMotor,
      validateProgressBar,
      setRegData,
      handleNcbRetentionModal,
      closeNcbRetentionModal,
      handleNcbRetentionProceed,
      handleNcbRetentionCancel,
      changeGstValidation,
      validateRegBusiness,
      getSumInsured
    };
  },
  directives: {
    evolvews: functions.evolvews
  },
};
</script>
<style>
.trans-header-class{
  font-size: 18px;
}
.trans-pol-class{
  width: 103.5%;
}
.partystatusclass {
    color: #f77a7a;
    font-size: 16px;
}
/* for radtio btn for registered business */
.vehicle-owned-wrap {
  display: flex;
  font-size: 14px;
}
.vehicle-owned-switch {
  position: relative;
  width: 181px;
  max-width: 452px;
  padding: 0 1rem;
}
.vehicle-owned-switch:before {
  content: '  ';
  position: absolute;
  left: 0;
  z-index: -1;
  background-color: #b3e5fb;
  padding: 6px 0;
  border-radius: 20px;
  color: #616161;
  font-size: 14px;
  width: 100%;
  min-height: 43px;
}
.chassis-input, .engine-input{
  text-transform:uppercase;
}
.success-gst{
  color: #0070be;
  font-size: 14px;
}
.vehicle-owned-switch-label {
  display: inline-block;
  width: 33%;
  padding: 11px 0;
  cursor: pointer;
  transition: color 200ms ease-out;
  z-index: 1;
}
.vehicle-owned-switch-indicator {
  width:80px;
  height:100px;
  line-height: 30px;
  background-color: #0070be;
  border-radius: 20px;
  max-height: 30px;
  position: absolute;
  top: 6px;
  left: 0;
  z-index: -1;
  transition: transform 600ms cubic-bezier(0.02, 0.94, 0.09, 0.97), background 300ms cubic-bezier(0.17, 0.67, 0.14, 1.03);
}
.vehicle-owned-switch input#registered:checked~.vehicle-owned-switch-indicator {
  transform: translateX(8px);
}
.vehicle-owned-switch input#not-registered:checked~.vehicle-owned-switch-indicator {
  transform: translateX(95px);
}
.vehicle-owned-switch input[type="radio"]:not(:checked),
.vehicle-owned-switch input[type="radio"]:checked {
  display: none;
}
.vehicle-owned-switch input[type="radio"]:checked +.vehicle-owned-switch-label{
  color: #ffffff;
  font-weight: bold;
  letter-spacing: normal;
}
.vehicleownswitch{
  padding-left: 58px
}
.disable-temp-block{
  opacity: 0.6;
  pointer-events: none;
}
::-webkit-input-placeholder { /* WebKit browsers */
  text-transform: none;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  text-transform: none;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  text-transform: none;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
  text-transform: none;
}
::placeholder { /* Recent browsers */
  text-transform: none;
}
/* for radio btn for switch party */
.types-of-plans-form-box{
    padding-top:0;      
}
.party-switch {
  position: relative;
  width: 100%;
  max-width: 238px;
  padding: 0 1rem;
}
.party-switch:before {
  content: '  ';
  position: absolute;
  left: 0;
  z-index: -1;
  background-color: #b3e5fb;
  padding: 6px 0;
  border-radius: 20px;
  color: #616161;
  font-size: 14px;
  width: 100%;
  min-height: 43px;
}
.party-switch-label {
  display: inline-block;
  width: 50%;
  padding: 11px 0;
  cursor: pointer;
  transition: color 200ms ease-out;
  z-index: 1;
}
.text-overflow-fix{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}
.party-switch-indicator {
  width:105px;
  height:100px;
  line-height: 30px;
  background-color: #0070be;
  border-radius: 20px;
  max-height: 30px;
  position: absolute;
  top: 6px;
  left: 0;
  z-index: -1;
  transition: transform 600ms cubic-bezier(0.02, 0.94, 0.09, 0.97), background 300ms cubic-bezier(0.17, 0.67, 0.14, 1.03);
}
.party-switch input#motor-party:checked~.party-switch-indicator {
  transform: translateX(8px);
}

.party-switch input#party-personal-guard:checked~.party-switch-indicator {
  transform: translateX(102px);
  width: 126px;
}

.party-switch input#hospital-cash:checked~.party-switch-indicator {
  transform: translateX(330px);
}

.party-switch input[type="radio"]:not(:checked),
.party-switch input[type="radio"]:checked {
  display: none;
}
.party-switch input[type="radio"]:checked +.party-switch-label{
  color: #ffffff;
  font-weight: bold;
  letter-spacing: normal;
}
.party-switch .party-personal-guard{
  padding-right: 10px;
}
.party-switch .hospital-cash{
  padding-right: 5px;
}
input[type="radio"].bgc-radio + label::before {
  left: -27px;
}
.search-loader img{
  width: 25px;
  height: 25px;
  left: 77%;
  top: 25%;
  position: absolute;
}
.search-loader-gst img{
  width: 25px;
  height: 25px;
  left: 83%;
  top: 45%;
  position: absolute;
}
.radio-status {
  margin-top: 30px;
}
@media (max-width: 369px) {
  .radio-status {
    margin-top: 0px;
  }
}
@media (max-width: 575px) {
  .adv-search-div {
    margin-top: 0px;
    position: relative;
    left: -11px;
  }
  .add-wrapper {
    line-height: 20px;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .adv-search-div {
    position: relative;
    bottom: 47%;
    left: 100%;
  }
}
input[type="text"].search-input-field {
  width: 80%;
  margin-right: 0;
  display: inline-block;
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
a.bgc-links.adv-search {
  text-decoration: none;
  font-size: 14px;
  color: #0872b9;
  font-weight: 400;
}
.input-group-text img {
  width: 24px;
}
.input-group-text {
  border: 0px;
  background-color: white;
}
/* // party code style */
@media (max-width: 575px) {
  .adv-search-div {
    margin-top: 0px;
  }
  .searchNumber {
    margin-bottom: 0px;
  }
}
@media (max-width: 767px) {
  .searchNumber {
    margin-bottom: 0px;
  }
}
.existing-party-id {
  position: relative;
  height: 52px;
  
}
.search-field-btn {
  display: inline-block;
  border: 1px solid #ccc;
  border-left: none;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  margin-top: 0;
  position: absolute;
  cursor: pointer;
  background-color: #fff;
}
.search-input-field:focus {
  border: 1px solid #ced4da;
}
input[type="text"].search-input-field {
  width: 82%;
  margin-right: 0;
  display: inline-block;
  border-right: none;
  border: 1px solid #ccc;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
@media (min-width: 680px) and (max-width: 767px) {
  input[type="text"].search-input-field {
    max-width:84%;
    width: 100%;
    border: 1px solid #ccc;
  }
}
@media (max-width: 575px) and (min-width: 460px) {
  input[type="text"].search-input-field {
    width: 88%;
    border: 1px solid #ccc;
  }
}
@media (max-width: 461px) and (min-width: 380px) {
  input[type="text"].search-input-field {
    width: 85%;
    border: 1px solid #ccc;
  }
}
@media (max-width: 381px) and (min-width: 330px) {
  input[type="text"].search-input-field {
    width: 82%;
    border: 1px solid #ccc;
  }
}
@media (max-width: 1100px) and (min-width: 767px) {
  input[type="text"].search-input-field {
    max-width: 75%;
    width: 100%;
  }
} 
</style>